document.addEventListener('DOMContentLoaded', () => {
  const filterClose = document.querySelector('.close-filter');
  const filterToggle = document.querySelector('#filterToggle');

  if (filterClose && filterToggle) {
    filterClose.addEventListener('click', event => {
      filterToggle.checked = false;
    });
  }
});